<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-6': mobile,
          'pt-4': mobile,
          'd-flex': mobile,
          'flex-column': mobile
        }"
      >
        <div class="d-flex flex-row">
          <p class="subtitle-1 font-weight-bold mb-2">
            Create Multiple Payment Requests
          </p>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon small class="pl-1 pb-2" v-on="on">mdi-help-circle</v-icon>
            </template>
            <p class="white--text" style="width: 300px">
              To create multiple payment requests, download the Excel-compatible
              CSV template first, then upload the populated file here.
            </p>
          </v-tooltip>
        </div>
        <v-btn
          :small="mobile"
          depressed
          color="primary"
          block
          class="pa-6"
          @click="fetchCSVTemplate"
          >Download template & <br v-if="mobile" />
          tenant list</v-btn
        >
        <vue-dropzone
          id="dropzone"
          ref="dropzone"
          class="mt-4 mb-2"
          :options="dropzoneOptions"
          @vdropzone-success="fileChanged"
          @vdropzone-removed-file="fileChanged"
        ></vue-dropzone>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            :disabled="!acceptedFiles.length"
            @click="finish"
            >Upload File</v-btn
          >
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        // headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        dictDefaultMessage:
          "<i class='v-icon mdi mdi-cloud-upload theme--light pr-2'></i><p class='grey--text text--darken-1 font-weight-bold'>Drop files here to upload</p>"
      },
      resolve: null,
      reject: null,
      acceptedFiles: []
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    async open() {
      this.dialog = true
      this.loading = false
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      this.loading = true
      if (
        await this.$root.$confirm({
          message: `Are you sure you want to upload this file?`,
          confirmText: 'Yes',
          options: {
            width: 400
          }
        })
      ) {
        const acceptedFiles = this.$refs.dropzone.getAcceptedFiles()
        this.$store
          .dispatch('payments/uploadMultiplePaymentsAction', {
            files: acceptedFiles
          })
          .then(() => {
            this.resolve(true)
            this.dialog = false
          })
          .catch((err) => {
            this.$root
              .$confirm({
                title: 'Create Multiple Payment Requests',
                message: err,
                reconfirmOnly: true,
                confirmText: 'OK',
                options: {
                  width: 350
                }
              })
              .then(() => {
                this.loading = false
              })
          })
      } else {
        this.loading = false
      }
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
    fetchCSVTemplate() {
      this.$store.dispatch('payments/fetchCSVTemplate')
    },
    fileChanged() {
      this.acceptedFiles = this.$refs.dropzone.getAcceptedFiles()
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
